module.exports = __webpack_public_path__ + "media/images/menu-saved-queries-icon-3f74a531e466b57fa021756a40168c82.svg";